import React, { Component } from 'react';
import WordDisplay from './WordDisplay.js';
import LetterColours from './LetterColours.js';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import UnsetLettersDialog from './components/UnsetLettersDialog.js';
import UnsetWordsDialog from './components/UnsetWordsDialog.js';
import FeedbackForm from './components/FeedbackForm.js';
import { observer, inject } from 'mobx-react';



const styles = theme => ({
    root: {
        width: '90%',
        display: 'inline-block'
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    buttonDiv: {
        display: 'inline-block'
    }
    
});

function getSteps() {
    return ['Enter letter colours', 'Colour words', 'Fill out a questionnaire'];
}

function getStepContent(step) {
    switch (step) {
        case 0:
            return 'Enter your standard colours for single letters. ';
        case 1:
            return 'Please adjust colours for these words, and mark them as set when you are happy.  Once the current list are set, please add more words!';
        case 2:
            return '';
        default:
            return 'Unknown step';
    }
}



@inject( 'wcpStore' )
@observer
class TabControl extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            showUnsetLetters: false,
            showUnsetWords: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    moveToPage(index) {

        if (index === this.state.activeStep) return;

        if (this.state.activeStep === 0 && !this.props.wcpStore.allLettersSet()) {
            this.setState({
                showUnsetLetters: true
            });
        } else if (index == 2 && !this.props.wcpStore.firstWordsLocked()) {
            this.setState({
                activeStep: 1,
                showUnsetWords: true
            });
        } else {
            this.setState({
                activeStep: index,
            });
        }
    }

    handleStep = index => () => {
        this.moveToPage(index);
    };
    
    handleNext = () => {
        if (this.state.activeStep == 2) {
            this.props.handlePageFinished();
        } else {
            this.moveToPage(this.state.activeStep + 1);
        }
    };

    handleBack = () => {
        this.moveToPage(this.state.activeStep - 1);
    };

    handleUnsetModalClose = (result) => {
        if (result) {
            // set all letters
            this.props.wcpStore.setUnsetLetters();
            this.setState({
                activeStep: 1,
                showUnsetLetters: false
            });
        } else {
            this.setState({
                showUnsetLetters: false
            });
        }
    }

    handleUnsetWordsModalClose = (result) => {
        this.setState({ showUnsetWords: false});

    }


    render() {

        const { classes } = this.props;
        const steps = getSteps();
        const { activeStep, showUnsetLetters, showUnsetWords } = this.state;
        const {letterColours, setLetterColour } = this.props.wcpStore;

        return (
        <div className={classes.root}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => {
                    const props = {};
                    const labelProps = {};
                    return (
                        <Step key={label} {...props}>

                            <StepButton onClick={this.handleStep(index)} {...labelProps}>{label}</StepButton>
                        </Step>
                    );
                })}
            </Stepper>
            <div>
                {activeStep === steps.length ? (
                    <div>
                        <Typography className={classes.instructions}>
                            All steps completed - you&apos;re finished
                        </Typography>
                    </div>
                ) : (
                    <div>
                        <Typography className={classes.instructions}>{getStepContent(activeStep)}

                        </Typography>
                    </div>
                )}
            </div>
            {activeStep === 0 && <LetterColours letterColours={letterColours} setLetterColour={setLetterColour} />}
            {activeStep === 1 && <WordDisplay/>}
            {activeStep === 2 && <FeedbackForm/>}
            <div style = {{ marginBottom: 100 }}>
                <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    className={classes.button}
                >
                    Back
                </Button>
                <Button
                    disabled={activeStep === steps.length}
                    variant="contained"
                    color="primary"
                    onClick={this.handleNext}
                    className={classes.button}
                >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                </Button>
            </div>
            <UnsetLettersDialog open={showUnsetLetters} onClose={this.handleUnsetModalClose}/>
            <UnsetWordsDialog open={showUnsetWords} onClose={this.handleUnsetWordsModalClose}/>
            <p>Copyright Jennifer Mankin 2020</p>
        </div>
        );
    }
}



export default  withStyles(styles)(TabControl);